import { render, staticRenderFns } from "./prepare-invest-offer-form-files-item.vue?vue&type=template&id=515c0782&scoped=true&"
import script from "./prepare-invest-offer-form-files-item.vue?vue&type=script&lang=js&"
export * from "./prepare-invest-offer-form-files-item.vue?vue&type=script&lang=js&"
import style0 from "./prepare-invest-offer-form-files-item.vue?vue&type=style&index=0&id=515c0782&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c0782",
  null
  
)

export default component.exports